<template>
  <div id="orderList">
    <!-- 订单分类 -->
    <div class="tab">
      <!-- <ul class="top">
        <li @click="tabClick(1)" :class="tab == 1 ? 'active' : ''">趣豆订单</li>
        <li @click="tabClick(2)" :class="tab == 2 ? 'active' : ''">转让订单</li>
      </ul> -->
      <!-- 趣豆tab -->
      <ul class="bottom" v-show="tab == 1">
        <li @click="pointsTabClick(-1)">
          <span :class="pointsTab == -1 ? 'active' : ''">全部</span>
        </li>
        <li @click="pointsTabClick(0)">
          <span :class="pointsTab == 0 ? 'active' : ''">已完成</span>
        </li>
        <li @click="pointsTabClick(1)">
          <span :class="pointsTab == 1 ? 'active' : ''">售后</span>
        </li>
      </ul>
      <!-- 转让tab -->
      <ul class="bottom" v-show="tab == 2">
        <li @click="transferTabClick(-1)">
          <span :class="transferTab == -1 ? 'active' : ''">全部</span>
        </li>
        <li @click="transferTabClick(0)">
          <span :class="transferTab == 0 ? 'active' : ''">进行中</span>
        </li>
        <li @click="transferTabClick(1)">
          <span :class="transferTab == 1 ? 'active' : ''">已完成</span>
        </li>
      </ul>
    </div>

    <!-- 订单列表 -->
    <ul
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
      infinite-scroll-immediate-check="false"
      class="list"
    >
      <li
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item)"
      >
        <div class="top">
          <p>
            <span>订单号：{{ item.orderNo }}</span>
            <span v-show="tab == 1"
              >交易状态：{{ item.orderStatus | orderStateCode }}</span
            >
            <span v-show="tab == 2"
              >交易状态：{{ item.orderStatus | orderStateTranfer }}</span
            >
          </p>
        </div>
        <div class="bottom">
          <div class="img-box">
            <!-- <img v-if="tab == 1" :src="host + item.goodsPhoto" /> -->
            <img v-if="item.type == 0" :src="host + item.goodsPhoto" />
            <img v-if="item.type == 1" src="@/static/images/home/huafei.png" />
            <img v-if="item.type == 2" src="@/static/images/home/shihua.png" />
            <img v-if="item.type == 3" src="@/static/images/home/shiyou.png" />
            <img v-if="tab == 2" src="@/static/images/other/pia_s.png" />
          </div>
          <div class="info">
            <p class="title" v-if="tab == 1">{{ item.goodsName }}</p>
            <p class="title" v-if="tab == 2">{{ item.ticketName }}</p>
            <div class="middle">
              <p>交易时间：{{ item.createTime }}</p>
              <p v-if="tab == 2">转让时间：{{ item.finishTime || "-" }}</p>
            </div>
            <div class="end">
              <span v-if="tab == 1">交易趣豆：{{ item.orderPrice }}</span>
              <span v-if="tab == 2">交易面值：{{ item.ticketPrice }}元</span>
              <div class="btn" v-if="tab == 1">
                <!-- <mt-button size="large" type="primary" @click="use()"
                  >使用</mt-button
                > -->
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="loading" v-show="loading">
          <mt-spinner type="fading-circle"></mt-spinner>
          <p>加载中...</p>
        </div>
        <div class="loading" v-show="loadAll">
          <p>已加载全部</p>
        </div>
      </li>
    </ul>
    <NoData v-show="noData" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      tab: "1", //趣豆订单 1 转让订单 2
      pointsTab: "-1", //趣豆tab  全部 -1 已完成0 售后1
      transferTab: "-1", //转让tab  全部-1 进行中0 已完成1
      loading: false,
      loadAll: false,
      noData: false,
      list: [],
      pageNo: "1",
      pageSize: "10",
      type: "", //  0自有订单  1话费充值  2中石化  3中石油
    };
  },
  mounted() {
    this.tab = this.$route.params.id;

    if (this.tab == 1) {
      this.getMemberInfo(() => {
        this.getPointsList();
      });
      document.title = "我的订单";
    } else {
      this.getTransferList();
      this.getMemberInfo(() => {
        this.getTransferList();
      });
      document.title = "我的转让";
    }
  },

  methods: {
    // 获取趣豆订单列表
    getPointsList(fn) {
      let orderStatus = this.pointsTab == -1 ? "" : this.pointsTab;
      this.post(this.apis.myOrderBuyList, {
        orderStatus,
        memberId: this.userInfo.memberId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.list = [...this.list, ...response.data.list];
            //处理订单类型
            this.list.map((item) => {
              item["type"] = this.orderType(item.orderType, item.oilCompany);
            });
            if (fn) {
              fn();
            }

            if (response.data.list.length == 0 && this.pageNo != 1) {
              this.loadAll = true;
            }
            if (!this.loadAll && response.data.list.length == 0) {
              this.noData = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取转让订单列表
    getTransferList(fn) {
      let orderStatus = this.transferTab == -1 ? "" : this.transferTab;
      this.post(this.apis.myOrderTransferList, {
        orderStatus,
        memberId: this.userInfo.memberId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.list = [...this.list, ...response.data.list];
            if (fn) {
              fn();
            }

            if (response.data.list.length == 0 && this.pageNo != 1) {
              this.loadAll = true;
            }
            if (!this.loadAll && response.data.list.length == 0) {
              this.noData = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 趣豆tabclick
    pointsTabClick(n) {
      this.scrollTop();
      this.pointsTab = n;
      setTimeout(() => {
        // this.changeRouter("/orderList/" + n);
        this.loading = false;
        this.loadAll = false;
        this.noData = false;
        this.list = [];
        this.pageNo = "1";
        this.pageSize = "10";
        this.getPointsList();
      }, 300);
    },
    // 转让tabclick
    transferTabClick(n) {
      this.scrollTop();
      this.transferTab = n;
      setTimeout(() => {
        // this.changeRouter("/orderList/" + n);
        this.loading = false;
        this.loadAll = false;
        this.noData = false;
        this.list = [];
        this.pageNo = "1";
        this.pageSize = "10";
        this.getTransferList();
      }, 300);
    },
    toDetail(item) {
      this.$router.push({
        name: "OrderDetail",
        params: { id: this.tab, orderId: item.id },
      });
    },
    //使用
    use(item) {
      console.log("toDetail -> item", item);
    },
    loadMore() {
      if (this.loadAll) {
        return;
      }
      this.loading = true;
      this.pageNo++;
      if (this.tab == 1) {
        this.getPointsList(() => {
          this.loading = false;
        });
      } else {
        this.getTransferList(() => {
          this.loading = false;
        });
      }
    },
    orderType(orderType, oilCompany) {
      // type  0自有订单  1话费充值  2中石化  3中石油
      let type;
      //判断订单类型
      if ("0" == orderType) {
        //自有订单,已经关联商品表了
        type = 0;
      } else if ("1" == orderType) {
        //话费充值
        type = 1;
      } else if ("2" == orderType) {
        if ("1" == oilCompany) {
          //中石化
          type = 2;
        } else if ("2" == oilCompany) {
          //中石油
          type = 3;
        }
      }
      return type;
    },
    ...mapMutations(["setUserInfo"]),
  },
  computed: {
    ...mapState(["openIdKey", "userInfo"]),
  },
  filters: {
    orderStateCode(val) {
      let ret = "";
      switch (parseInt(val)) {
        case 0:
          ret = "已完成";
          break;
        case 1:
          ret = "售后";
          break;
      }
      return ret;
    },
    orderStateTranfer(val) {
      let ret = "";
      switch (parseInt(val)) {
        case 0:
          ret = "进行中";
          break;
        case 1:
          ret = "已完成";
          break;
      }
      return ret;
    },
  },
};
</script>

<style lang="less" scoped>
#orderList {
  .tab {
    width: 100%;
    background-color: #fff;
    position: fixed;
    height: 100px;
    z-index: 100;
    .top {
      padding: 38px 30px 0;
      display: flex;
      li {
        &::first-child {
          width: 112px;
        }
        border-radius: 4px;
        border: solid 1px #1fbe6e;
        line-height: 54px;
        text-align: center;
        margin-right: 16px;
        padding: 0 24px;
        color: #283349;
        &.active {
          background-color: #1fbe6e;
          color: #ffffff;
        }
      }
    }
    .bottom {
      padding: 54px 30px 0;
      display: flex;
      justify-content: space-between;
      li {
        flex: 1;
        text-align: center;
        span {
          height: 25px;
          font-family: PingFang-SC-Bold;
          font-size: 26px;
          font-weight: bold;
          line-height: 36px;
          color: #283349;
          border-bottom: 6px solid transparent;
          &.active {
            color: #1fbe6e;
            border-bottom: 6px solid #1fbe6e;
          }
        }
      }
    }
  }
  .list {
    padding: 126px 30px 0;
    margin: 0 auto;
    background-color: #fafafa;
    .item {
      width: 691px;
      background-color: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(163, 163, 163, 0.45);
      border-radius: 10px;
      margin-bottom: 26px;
      .top {
        height: 88px;
        font-family: PingFang-SC-Regular;
        font-size: 24px;
        color: #3a3a3a;
        p {
          line-height: 88px;
          padding-left: 18px;
          display: flex;
          span {
            flex: 1;
            &:first-child {
              flex: 0 0 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 40px;
            }
          }
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        padding-bottom: 30px;
        .img-box {
          width: 168px;
          height: 168px;
          display: flex;
          align-items: center;
          margin-left: 18px;
          margin-right: 24px;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
        .info {
          .title {
            width: 500px;
            font-weight: bold;
            font-family: PingFang-SC-Bold;
            font-size: 30px;
            color: #3a3a3a;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-bottom: 5px;
          }
          .middle {
            height: 60px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            padding-top: 2px;
            p {
              padding-bottom: 3px;
            }
          }
          .end {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            padding-right: 20px;
            .mint-button--large {
              width: 160px;
              height: 50px;
            }
          }
        }
      }
    }
  }
}
</style>
